import React from 'react';
import './wining.css'
import Header from '../components/layout/header';
import pic11 from '../assets/pic11.png'
import pic48 from '../assets/pic48.png'
import Settings from '../components/common/settings';
import pic50 from '../assets/pic50.png'
import pic51 from '../assets/pic51.png'
import pic52 from '../assets/pic52.png'
import pic53 from '../assets/pic53.png'
import pic55 from '../assets/pic55.png'
import pic56 from '../assets/pic56.png'
import pic54 from '../assets/pic54.png'
import pic57 from '../assets/pic57.png'
import pic58 from '../assets/pic58.png'
import pic59 from '../assets/pic59.png'
import pic60 from '../assets/pic60.png'
import pic61 from '../assets/pic61.png'
import pic62 from '../assets/pic62.png'
import pic63 from '../assets/pic63.png'
import pic64 from '../assets/pic64.png'
import pic67 from '../assets/pic67.png'
import pic68 from '../assets/pic68.png'
import pic69 from '../assets/pic69.png'
import pic70 from '../assets/pic70.png'
import pic71 from '../assets/pic71.png'
import pic72 from '../assets/pic72.png'
import pic73 from '../assets/pic73.png'
import pic81 from '../assets/pic81.png'
import pic74 from '../assets/pic74.png'
import pic75 from '../assets/pic75.png'
import pic76 from '../assets/pic76.png'
import pic77 from '../assets/pic77.png'
import pic78 from '../assets/pic78.png'
import pic79 from '../assets/pic79.png'
import pic80 from '../assets/pic80.png'
import AudioContext from '../components/common/AudioContext';
import './howtoplayinstructions.css'
import Winingaudio from '../audio/Wining.mp3'
import './howtoplayinstructions.css'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import pic107 from '../assets/pic107.png'
import pic97 from '../assets/pic97.png'
import pic98 from '../assets/pic98.png'
import pic99 from '../assets/pic99.png'
import CircleNav from '../components/common/circlenav';
import pic104 from '../assets/pic104.png'
import pic106 from '../assets/pic106.png'
import PrimaryctaLong from '../components/common/primary cta long';
import pic103 from '../assets/pic103.png'
import pic96 from '../assets/pic96.png';
import { useEffect } from 'react';
import { useState } from 'react';
import pic145 from '../assets/pic145.png'
import pic178 from '../assets/pic178.png'
import pic222 from '../assets/pic222.png'
import pic231 from '../assets/pic231.png'

import pic49 from '../assets/pic49.png';
import pic239 from '../assets/pic239.png';
import pic232 from '../assets/pic232.png';
import pic235 from '../assets/pic235.png';

const Wining = () =>{
    const [settingsOpen, setSettingsOpen] =useState(false);
    const { soundVolume } = React.useContext(AudioContext);
    const audioRef = React.useRef(null);
    const [closing, setClosing] = useState(false);
     const navigate = useNavigate();
     const [nexting, setNexting] = useState(false);
      const location = useLocation();
      const score = location.state?.score || 0;
      const lives = location.state?.lives || 0;
      const collected = location.state?.collected || 0;
      const level = location.state?.level || 1;

        const levelBackgrounds = {
                  1: pic49,
                  2: pic239,
                  3: pic232,
                  4: pic235
              };
      
              const currentBackground = levelBackgrounds[level];
      

    const starCount = lives;
         const selectedCharacter =
    localStorage.getItem('selectedCharacter') || 'Mohammed Tout';

            const characterUnlockSeenKey =
                level === 1 ? 'character2UnlockSeen'
                : level === 2 ? 'character3UnlockSeen'
                : level === 3 ? 'character4UnlockSeen'
                : level === 4 ? 'character5UnlockSeen'
                : null;

            const wasAlreadyUnlockedRef = React.useRef(
                characterUnlockSeenKey
                    ? localStorage.getItem(characterUnlockSeenKey) === 'true'
                    : true
            );
        const nextLevelUnlockedRoute =
            level === 1 ? '/level2unlocked'
            : level === 2 ? '/level3unlocked'
            : level === 3 ? '/level4unlocked'
            : level === 4 ? '/level5unlocked'
            : '/levels';


    
    // let starCount = 1;

    // if (score >= 3600) {
    //     starCount = 3;
    // } else if (score >= 2600) {
    //     starCount = 2;
    // }
    useEffect(() => {
        if (level === 1) {
            localStorage.setItem('level1Stars', starCount);
        }
    }, [level, starCount]);

    useEffect(() => {
    if (level === 2) {
        localStorage.setItem('level2Stars', starCount);
        }
    }, [level, starCount]);


     useEffect(() => {
    if (level === 3) {
        localStorage.setItem('level3Stars', starCount);
        }
    }, [level, starCount]);   


     useEffect(() => {
    if (level === 4) {
        localStorage.setItem('level4Stars', starCount);
        }
    }, [level, starCount]);   


    useEffect(() => {
            const audio = audioRef.current;
            if (!audio) return;
            audio.volume = soundVolume;
            audio.play().catch(() => {});

            return () => {
                audio.pause();
                audio.currentTime = 0;
            };
        }, []);

    useEffect(() => {
            if (audioRef.current) audioRef.current.volume = soundVolume;
        }, [soundVolume]);


        useEffect(() => {
            if (level === 1) {
                localStorage.setItem('currentLevel', '2');
                  localStorage.setItem('character2Unlocked', 'true');
                // localStorage.setItem('selectedCharacter', 'Sarah Idress');
            }

            if (level === 2) {
                localStorage.setItem('currentLevel', '3');
                localStorage.setItem('character3Unlocked', 'true');
                // localStorage.setItem('selectedCharacter', 'Teyah Ramses');
            }


            if (level === 3) {
                localStorage.setItem('currentLevel', '4');
                localStorage.setItem('character4Unlocked', 'true');
                // localStorage.setItem('selectedCharacter', 'Ahmad Amon');
            }

            if (level === 4) {
                localStorage.setItem('currentLevel', '5');
                localStorage.setItem('character5Unlocked', 'true');
                // localStorage.setItem('selectedCharacter', 'Ahmad Amon');
            }


        }, [level]);
        // const handleBack = () => {
        // setClosing(true);
        // setTimeout(() => navigate('/Story', { state: { back: true } }), 400);
        // };

        // const handleNext = () => {
        // setNexting(true); 
        // setTimeout(() => navigate('/Misson'), 400);
        // };

    return ( 
        <>
             {closing && <div className='story-bg-behind' />}
<main className={`level1--page ${closing ? 'slide-down' : ''}`}>
            <section className='levelbackground--page'>
                 <audio ref={audioRef} src={Winingaudio} preload="auto" />
                 {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}
                <>

               <section className='settings-background'>
               <section  className={`wining-overlay-inst ${nexting ? 'slide-down' : 'slide-up'}`}>
                <section className='header-losing-overlay'>
                    <div className='header-title-cont-wining'>
                        <h2 className='title-containerr-settings'>You Win</h2>
                        <h2 className='title2-container-settings'>You Win</h2>
                    </div>
                    
                </section>


                <section className='container-losing'>
               
                            <h2 className='title-losing'>You collected All</h2>
                            <div className='stars-container-lose'>
                                <img
                                src={starCount >= 1 ? pic106 : pic96}
                                alt='left-star'    />

                            <h3 className='score-lose'>{score}</h3>

                            <img
                                src={starCount >= 3 ? pic106 : pic96}
                                alt='right-star'        />

                            <img
                                className='big-star-lose'
                                src={starCount >= 2 ? pic107 : pic97}
                                alt='middle-star'  />

                            </div>
                             <nav className='container-navs-losing'>
                                <CircleNav img2={pic98} icontext2='home'   onClick={() => navigate('/home')}/>
                              <CircleNav img2={pic99} icontext2='restart'  
                               onClick={() =>
                                    navigate(
                                        level === 4
                                        ? '/level4start'
                                       : level === 3
                                        ? '/level3start'
                                       : level === 1 
                                        ? '/level1start' 
                                        : '/level2start')
                                }/>                                
                             </nav>


                            <Link
                               to={wasAlreadyUnlockedRef.current ? nextLevelUnlockedRoute : '/unlockedcharacter'}
                                state={{ score, lives, collected,  starCount , level,
                                            level1Stars: level === 1 ? starCount : 0,
                                            level2Stars: level === 2 ? starCount : 0,
                                            level3Stars: level === 3 ? starCount : 0,
                                            level4Stars: level === 4 ? starCount : 0
                                 }}
                                className='linkkkunlocked'
                            >
                            <PrimaryctaLong title='Continue'/>
                            </Link>




                </section>

                </section>
                  <img className='decoration' src={pic103} alt='decoration'></img>
            </section>
           
            <img
                className={`character-happy ${nexting ? 'slide-down' : 'slide-up'}`}


                  src={
                    selectedCharacter === 'Ahmad Amon'
                     ? pic222
                    : selectedCharacter === 'Mariam Lotus'
                    ?pic231
                    : selectedCharacter === 'Teyah Ramses'
                     ? pic178
                     : selectedCharacter === 'Sarah Idress'
                        ? pic145
                         : pic104
                         }

                alt='character-happy'
            />
          
           
        </>
                  <div  className='background-and-obstacles-lose'
                        style={{
                            '--level-bg': `url(${currentBackground})`
                        }}
                        >
                    <div className='container-obtsacles-and-collections'>
                        <img className='obstacle1' src={pic57} alt='obstacle-1'/>
                        <img className='obstacle2' src={pic58} alt='obstacle-2'/>
                        <img className='obstacle3' src={pic59} alt='obstacle-3'/>
                        <img className='obstacle4' src={pic60} alt='obstacle-4'/>
                        <img className='obstacle5' src={pic61} alt='obstacle-5'/>
                        <img className='collect1' src={pic62} alt='collect-1'/>  
                        <img className='obstacle6' src={pic63} alt='obstacle-6'/>  
                        <img className='obstacle7' src={pic64} alt='obstacle-7'/>   
                        <img className='obstacle8' src={pic67} alt='obstacle-8'/>                          
                        <img className='obstacle9' src={pic68} alt='obstacle-9'/>  
                        <img className='obstacle10' src={pic69} alt='obstacle-10'/>  
                        <img className='obstacle11' src={pic70} alt='obstacle-11'/>  
                        <img className='obstacle12' src={pic71} alt='obstacle-12'/>  
                        <img className='obstacle13' src={pic72} alt='obstacle-12'/> 
                        <img className='obstacle14' src={pic73} alt='obstacle-14'/> 
                        <img className='obstacle15' src={pic81} alt='obstacle-14'/> 
                        <img className='obstacle16' src={pic74} alt='obstacle-14'/> 
                        <img className='obstacle17' src={pic75} alt='obstacle-17'/> 
                        <img className='obstacle18' src={pic76} alt='obstacle-18'/> 
                        <img className='obstacle19' src={pic77} alt='obstacle-19'/>  
                        <img className='obstacle20' src={pic78} alt='obstacle-20'/>                            
                        <img className='obstacle21' src={pic79} alt='obstacle-20'/> 
                        <img className='obstacle22' src={pic80} alt='obstacle-20'/> 

                    </div>
                </div>

   
                <section className='container-hedaer-and-character-levels-page'>
                    <Header 
                      title={`Level ${level}`}
                    title2={`Level ${level}`}
                    link='/home'  onClick={() => setSettingsOpen(true)}
                    img={pic48} icontext='pause icon'
                    img2={pic11} icontext2='settings icon'/>
                 <img className='character-movement' src={pic54} alt='character'></img>




                    <div className='HUD-container'>

                            <div className='lives-frame-Hud'>
                                <div className='lives-container-HUD'>
                                    <img className='decoration2-HUD' src={pic56} alt='decoration-HUD'></img>
                                    <div className='hearts-container'>
                                        <img src={pic53} alt='heart'></img>
                                        <img src={pic53} alt='heart'></img>
                                        <img src={pic53} alt='heart'></img>
                                    </div>
                                </div>
                            </div>

                        <div className='frame-Hud'>
                            <div className='HUD-1-container'>

                                <img className='decoration-HUD' src={pic55} alt='decoration-HUD'></img>

                                <h2 className='collect-text'>Collect:</h2>
                                <div className='row-pic-HUD'>
                                    <div className='img-container-HUD'> 
                                        <img src={pic50} alt='collect-item-1'></img>
                                    </div>

                                    <div className='img-container-HUD'> 
                                        <img src={pic51} alt='collect-item-1'></img>
                                    </div>


                                    <div className='img-container-HUD'> 
                                        <img src={pic52} alt='collect-item-1'></img>
                                    </div>

                                </div>
                            </div>


                        </div>
                    </div>



                </section>
            </section>
          </main>

         </>
     );
}
 
export default Wining;